export default __webpack_public_path__ + "static/schools-49e7f81ad6f6ad4f83777ff789508227.png";